import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { clearSessionTimeout, resetLastActivity } from "@/utils/sessionTimeout";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: {
      auth: false,
    },
  },
  mutations: {
    LOGIN: (state, data) => {
      state.login = data;
    },
    LOGOUT: (state) => {
      state.login = {
        auth: false,
      };
    },
    PASSWD_UPDATE: (state) => {
      state.login.passwd_update = false;
    },
  },
  actions: {
    logInAction: (context, data) => {
      context.commit("LOGIN", data);
      resetLastActivity();
    },
    logOutAction: (context) => {
      context.commit("LOGOUT");
      clearSessionTimeout();
    },
    passwdUpdateAction: (context) => {
      context.commit("PASSWD_UPDATE");
    },
  },
  getters: {
    getLogin: (state) => {
      return state.login;
    },
  },
  plugins: [createPersistedState()],
});
